import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext } from 'react';
import { S as SelectOptionDisplayName } from '../utils/displayNames-DWYGtsUp.js';
import { S as SelectListContext } from '../SelectListContext-D8hyna51.js';
import { M as MobileFullScreenRenderWrapper, a as MobileFullScreenButton, b as MobileFullScreenCheckbox, c as MobileFullScreenRadio, S as SelectButtonContent, R as RenderWrapper, d as SelectButton, C as Checkbox } from './SelectOption.styles-cNlD__dU.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { T as Text } from '../../Text/Text-BVGlY4So.js';

const valueSerializer = value => {
  try {
    if (value === null) {
      return value;
    }
    if (typeof value === 'undefined') {
      return value;
    }
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      return value;
    }
    return JSON.stringify(value);
  } catch (error) {
    return value;
  }
};
const isNotNullish = value => value !== undefined && value !== null;
const SelectOption = ({
  children,
  value,
  renderStart,
  renderEnd,
  renderAfter,
  disabled,
  taktId,
  taktValue,
  onClick: onClickExternal,
  selected: selectedExternal,
  noWrap: noWrapExternal,
  ...rest
}) => {
  const {
    mobileFullScreen,
    multiple,
    noWrap,
    onClick,
    selectedValue,
    afterOnSelect
  } = useContext(SelectListContext);
  if (value === undefined || value === null) return null;
  const selected = selectedExternal !== null && selectedExternal !== void 0 ? selectedExternal : isNotNullish(value) && (Array.isArray(selectedValue) ? selectedValue.includes(value) : value === selectedValue);
  const handleClick = event => {
    let onClickValue = value;
    if (multiple) {
      const previousSelectValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
      // @TODO: maybe serialize the value before comparison
      if (previousSelectValues.includes(value)) {
        onClickValue = previousSelectValues.filter(previousSelectValue => previousSelectValue !== value);
      } else {
        onClickValue = [...previousSelectValues, value];
      }
      onClickValue = onClickValue.filter(Boolean);
    }
    onClick === null || onClick === void 0 || onClick(onClickValue, event);
    onClickExternal === null || onClickExternal === void 0 || onClickExternal(onClickValue, event);
    afterOnSelect === null || afterOnSelect === void 0 || afterOnSelect();
  };
  const buttonProps = {
    ...rest,
    selected,
    disabled,
    type: 'button',
    onClick: handleClick,
    value: valueSerializer(value),
    variant: selected ? 'primary' : 'transparent',
    $multiple: multiple,
    role: 'option',
    'aria-selected': Boolean(selected)
  };
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('select-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, mobileFullScreen ? /*#__PURE__*/React__default.createElement(MobileFullScreenRenderWrapper, null, /*#__PURE__*/React__default.createElement(MobileFullScreenButton, _extends({}, getDataTaktAttributes(), buttonProps), multiple ? /*#__PURE__*/React__default.createElement(MobileFullScreenCheckbox, {
    size: "base",
    checked: selected,
    disabled: disabled
  }) : /*#__PURE__*/React__default.createElement(MobileFullScreenRadio, null), /*#__PURE__*/React__default.createElement(SelectButtonContent, null, /*#__PURE__*/React__default.createElement(Text, {
    color: disabled ? 'unavailable' : 'default'
  }, renderStart === null || renderStart === void 0 ? void 0 : renderStart(), children, renderEnd === null || renderEnd === void 0 ? void 0 : renderEnd()))), renderAfter === null || renderAfter === void 0 ? void 0 : renderAfter()) : /*#__PURE__*/React__default.createElement(RenderWrapper, {
    noWrap: noWrapExternal !== null && noWrapExternal !== void 0 ? noWrapExternal : noWrap
  }, /*#__PURE__*/React__default.createElement(SelectButton, _extends({}, getDataTaktAttributes(), buttonProps), multiple && /*#__PURE__*/React__default.createElement(Checkbox, {
    size: "base",
    checked: selected,
    disabled: disabled
  }), /*#__PURE__*/React__default.createElement(SelectButtonContent, null, renderStart === null || renderStart === void 0 ? void 0 : renderStart(), children, renderEnd === null || renderEnd === void 0 ? void 0 : renderEnd())), renderAfter === null || renderAfter === void 0 ? void 0 : renderAfter())));
};
SelectOption.displayName = SelectOptionDisplayName;

export { SelectOption as S };
//# sourceMappingURL=SelectOption-CnQJv6hB.js.map
